// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Photo6x6--wrapper--Yo819","box":"Photo6x6--box--1jfPV","terracotta":"Photo6x6--terracotta--2x_nT","clay":"Photo6x6--clay--2yflQ","emerald":"Photo6x6--emerald--10tvg"};